import styled from 'styled-components'

export const H1 = styled.h1`
  color: ${props => props.theme.colors.gray1};
  font-weight: 600;
`
